<div class="e-invoice-sign-up-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{ 'eInvoiceSignUp.Title' | translate }}</h2>
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <upsc-e-invoice-sign-up-form [contact]="contactStream | async"
                                     (contactRendered)="onContactRendered($event)"
                                     (formSubmitting)="onFormSubmitting($event)"></upsc-e-invoice-sign-up-form>

        <upsc-element-blocker *ngIf="isInProgress"></upsc-element-blocker>
    </mat-dialog-content>
</div>
